import { render, staticRenderFns } from "./Caminhao.vue?vue&type=template&id=4ce3c802&"
import script from "./Caminhao.vue?vue&type=script&lang=js&"
export * from "./Caminhao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports